export const cleverTapConfig = {
	accountId: 'TEST-9W8-9K6-5K7Z',
	region: 'eu1',
};

export const isCleverTapEnabled = true;
//   process.env.NODE_ENV === 'production' ||
//   process.env.NEXT_PUBLIC_CLEVERTAP_ENABLED === 'true';
